// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import type { GetProfilesData, GetProfilesError, GetProfilesResponse, GetEngagementOverviewData, GetEngagementOverviewError, GetEngagementOverviewResponse, GetLoanOverviewsData, GetLoanOverviewsError, GetLoanOverviewsResponse, GetAccountOverviewsData, GetAccountOverviewsError, GetAccountOverviewsResponse, GetAccountDetailsData, GetAccountDetailsError, GetAccountDetailsResponse, GetInvestmentOverviewsData, GetInvestmentOverviewsError, GetInvestmentOverviewsResponse, GetInternetAgreementData, GetInternetAgreementError, GetInternetAgreementResponse, GetNotAcceptedInternetAgreementData, GetNotAcceptedInternetAgreementError, GetNotAcceptedInternetAgreementResponse, GetInvestmentAmountsData, GetInvestmentAmountsError, GetInvestmentAmountsResponse, GetProfileQuickInfoData, GetProfileQuickInfoError, GetProfileQuickInfoResponse, GetContactInformationData, GetContactInformationError, GetContactInformationResponse, AcceptInternetAgreementData, AcceptInternetAgreementError, AcceptInternetAgreementResponse, GetInternetAgreementVersionsData, GetInternetAgreementVersionsError, GetInternetAgreementVersionsResponse, GetInvestmentInformationError, GetInvestmentInformationResponse, GetInvestmentInformationForProfileData, GetInvestmentInformationForProfileError, GetInvestmentInformationForProfileResponse, GetAccountTransactionsData, GetAccountTransactionsError, GetAccountTransactionsResponse, SetAccountNameData, SetAccountNameError, SetAccountNameResponse, GetFutureTransactionsData, GetFutureTransactionsError, GetFutureTransactionsResponse, DeleteFutureTransactionData, DeleteFutureTransactionError, DeleteFutureTransactionResponse, CreateInvestmentOrderData, CreateInvestmentOrderError, CreateInvestmentOrderResponse, CompleteInvestmentOrderData, CompleteInvestmentOrderError, CompleteInvestmentOrderResponse, CheckOrderData, CheckOrderError, CheckOrderResponse2, UpdateContactInformationData, UpdateContactInformationError, UpdateContactInformationResponse } from './types.gen';

export const client = createClient(createConfig());

export class CustomerGatewayService {
    public static getProfiles<ThrowOnError extends boolean = false>(options?: Options<GetProfilesData, ThrowOnError>) {
        return (options?.client ?? client).get<GetProfilesResponse, GetProfilesError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles'
        });
    }
    
    public static getEngagementOverview<ThrowOnError extends boolean = false>(options: Options<GetEngagementOverviewData, ThrowOnError>) {
        return (options?.client ?? client).get<GetEngagementOverviewResponse, GetEngagementOverviewError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/overview'
        });
    }
    
    public static getLoanOverviews<ThrowOnError extends boolean = false>(options: Options<GetLoanOverviewsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetLoanOverviewsResponse, GetLoanOverviewsError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/loans'
        });
    }
    
    public static getAccountOverviews<ThrowOnError extends boolean = false>(options: Options<GetAccountOverviewsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAccountOverviewsResponse, GetAccountOverviewsError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/accounts'
        });
    }
    
    public static getAccountDetails<ThrowOnError extends boolean = false>(options: Options<GetAccountDetailsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAccountDetailsResponse, GetAccountDetailsError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/accounts/{area}/{accountNumber}/details'
        });
    }
    
    public static getInvestmentOverviews<ThrowOnError extends boolean = false>(options: Options<GetInvestmentOverviewsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetInvestmentOverviewsResponse, GetInvestmentOverviewsError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/investments'
        });
    }
    
    public static getInternetAgreement<ThrowOnError extends boolean = false>(options: Options<GetInternetAgreementData, ThrowOnError>) {
        return (options?.client ?? client).get<GetInternetAgreementResponse, GetInternetAgreementError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/internetAgreements/{agreementId}'
        });
    }
    
    public static getNotAcceptedInternetAgreement<ThrowOnError extends boolean = false>(options: Options<GetNotAcceptedInternetAgreementData, ThrowOnError>) {
        return (options?.client ?? client).get<GetNotAcceptedInternetAgreementResponse, GetNotAcceptedInternetAgreementError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/internetAgreements/notaccepted'
        });
    }
    
    public static getInvestmentAmounts<ThrowOnError extends boolean = false>(options: Options<GetInvestmentAmountsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetInvestmentAmountsResponse, GetInvestmentAmountsError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/investmentAmounts'
        });
    }
    
    public static getProfileQuickInfo<ThrowOnError extends boolean = false>(options: Options<GetProfileQuickInfoData, ThrowOnError>) {
        return (options?.client ?? client).get<GetProfileQuickInfoResponse, GetProfileQuickInfoError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/quickinfo'
        });
    }
    
    public static getContactInformation<ThrowOnError extends boolean = false>(options: Options<GetContactInformationData, ThrowOnError>) {
        return (options?.client ?? client).get<GetContactInformationResponse, GetContactInformationError, ThrowOnError>({
            ...options,
            url: '/contactInformation/{profileId}'
        });
    }
    
}

export class PartyMasterService {
    public static acceptInternetAgreement<ThrowOnError extends boolean = false>(options: Options<AcceptInternetAgreementData, ThrowOnError>) {
        return (options?.client ?? client).post<AcceptInternetAgreementResponse, AcceptInternetAgreementError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/internetAgreements/{agreementId}'
        });
    }
    
    public static getInternetAgreementVersions<ThrowOnError extends boolean = false>(options: Options<GetInternetAgreementVersionsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetInternetAgreementVersionsResponse, GetInternetAgreementVersionsError, ThrowOnError>({
            ...options,
            url: '/internetagreements/{agreementId}/versions'
        });
    }
    
}

export class CustomerService {
    public static getInvestmentInformation<ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<GetInvestmentInformationResponse, GetInvestmentInformationError, ThrowOnError>({
            ...options,
            url: '/engagement/investmentInfo'
        });
    }
    
    public static getInvestmentInformationForProfile<ThrowOnError extends boolean = false>(options: Options<GetInvestmentInformationForProfileData, ThrowOnError>) {
        return (options?.client ?? client).get<GetInvestmentInformationForProfileResponse, GetInvestmentInformationForProfileError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/investmentInfo'
        });
    }
    
}

export class AccountService {
    public static getAccountTransactions<ThrowOnError extends boolean = false>(options: Options<GetAccountTransactionsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAccountTransactionsResponse, GetAccountTransactionsError, ThrowOnError>({
            ...options,
            url: '/accounts/{area}/{accountNumber}/transactions'
        });
    }
    
    public static setAccountName<ThrowOnError extends boolean = false>(options: Options<SetAccountNameData, ThrowOnError>) {
        return (options?.client ?? client).post<SetAccountNameResponse, SetAccountNameError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/accounts/{area}/{accountNumber}/name'
        });
    }
    
    public static getFutureTransactions<ThrowOnError extends boolean = false>(options: Options<GetFutureTransactionsData, ThrowOnError>) {
        return (options?.client ?? client).get<GetFutureTransactionsResponse, GetFutureTransactionsError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/transactions/future'
        });
    }
    
    public static deleteFutureTransaction<ThrowOnError extends boolean = false>(options: Options<DeleteFutureTransactionData, ThrowOnError>) {
        return (options?.client ?? client).delete<DeleteFutureTransactionResponse, DeleteFutureTransactionError, ThrowOnError>({
            ...options,
            url: '/engagement/profiles/{profileId}/transactions/future/{transactionId}'
        });
    }
    
}

export class DefaultService {
    public static createInvestmentOrder<ThrowOnError extends boolean = false>(options: Options<CreateInvestmentOrderData, ThrowOnError>) {
        return (options?.client ?? client).post<CreateInvestmentOrderResponse, CreateInvestmentOrderError, ThrowOnError>({
            ...options,
            url: '/invest'
        });
    }
    
    public static completeInvestmentOrder<ThrowOnError extends boolean = false>(options: Options<CompleteInvestmentOrderData, ThrowOnError>) {
        return (options?.client ?? client).put<CompleteInvestmentOrderResponse, CompleteInvestmentOrderError, ThrowOnError>({
            ...options,
            url: '/invest'
        });
    }
    
    public static checkOrder<ThrowOnError extends boolean = false>(options: Options<CheckOrderData, ThrowOnError>) {
        return (options?.client ?? client).get<CheckOrderResponse2, CheckOrderError, ThrowOnError>({
            ...options,
            url: '/checkOrder/{orderId}'
        });
    }
    
}

export class ContactInformationService {
    public static updateContactInformation<ThrowOnError extends boolean = false>(options: Options<UpdateContactInformationData, ThrowOnError>) {
        return (options?.client ?? client).post<UpdateContactInformationResponse, UpdateContactInformationError, ThrowOnError>({
            ...options,
            url: '/contactInformation/{profileId}'
        });
    }
    
}